import styles from './VersionDisplay.module.css'

interface VersionDisplayProps {
    readonly onClick?: () => void
}

export function VersionDisplay({ onClick }: VersionDisplayProps) {
    const version = __APP_VERSION__

    return (
        <div 
            className={styles.container} 
            onClick={onClick}
            title="Click to see what's new"
            data-testid="version-display"
        >
            <span>Bibliotelia</span>
            <span className={styles.versionBadge}>v{version}</span>
        </div>
    )
}
